/**
 * Подсказки «Блот / Реблот» по ходу K/Q козыря (только отображение; движок считает белу отдельно).
 */

import { belotCardIsTrump, belotCardRank } from './belotArmenianCards';

const RANK_K = 5;
const RANK_Q = 4;

/**
 * @param {unknown} trump — как в контракте (`0..3`, `all_trump`, `no_trump`)
 * @param {unknown} cardId
 * @returns {boolean}
 */
export function belotIsTrumpRoyalCard(trump, cardId) {
  if (trump === 'no_trump' || trump == null) return false;
  const c = Number(cardId);
  if (!Number.isInteger(c) || c < 0 || c > 31) return false;
  const r = belotCardRank(c);
  if (r !== RANK_K && r !== RANK_Q) return false;
  return belotCardIsTrump(trump, c);
}

/**
 * Команда места 0/2 → 0, 1/3 → 1
 * @param {number} seat
 */
export function belotTeamIndexForSeat(seat) {
  return seat === 0 || seat === 2 ? 0 : 1;
}

/**
 * После хода: вернуть 'blot' | 'reblot' | null и обновить счётчик королевских козырей по команде.
 *
 * @param {{
 *   trump: unknown,
 *   cardId: unknown,
 *   seat: number,
 *   royalsPlayedByTeam: [number, number],
 * }} args
 * @returns {{ kind: 'blot'|'reblot'|null, royalsPlayedByTeam: [number, number] }}
 */
export function belotAdvanceBelaSpeechState({ trump, cardId, seat, royalsPlayedByTeam }) {
  const next = /** @type {[number, number]} */ ([royalsPlayedByTeam[0], royalsPlayedByTeam[1]]);
  if (!belotIsTrumpRoyalCard(trump, cardId)) {
    return { kind: null, royalsPlayedByTeam: next };
  }
  const team = belotTeamIndexForSeat(seat);
  next[team] = Math.min(2, next[team] + 1);
  if (next[team] === 1) return { kind: 'blot', royalsPlayedByTeam: next };
  if (next[team] === 2) return { kind: 'reblot', royalsPlayedByTeam: next };
  return { kind: null, royalsPlayedByTeam: next };
}

/**
 * Сброс при новой раздаче / смене раунда.
 * @returns {[number, number]}
 */
export function belotFreshBelaRoyalsByTeam() {
  return [0, 0];
}

/**
 * Позиция и дрейф речевого баббла (Блот/Реблот) относительно места и героя.
 * `visualOffset` = (seat - hero + 4) % 4: 0 низ, 1/3 бок, 2 верх.
 *
 * @param {number} heroIndex 0..3
 * @param {number} seatIndex 0..3
 * @returns {{
 *   visualOffset: number,
 *   tailUp: boolean,
 *   bubbleClassName: string,
 *   driftX: number,
 *   driftY: number,
 * }}
 */
export function belotSeatBubblePlacement(heroIndex, seatIndex) {
  const h = Number(heroIndex);
  const s = Number(seatIndex);
  const hi = Number.isInteger(h) && h >= 0 && h <= 3 ? h : 0;
  const si = Number.isInteger(s) && s >= 0 && s <= 3 ? s : 0;
  const visualOffset = (si - hi + 4) % 4;
  const tailUp = visualOffset === 2;
  /** px: сдвинуть баббл к центру стола для боковых мест */
  const towardCenterPx = visualOffset === 1 ? -12 : visualOffset === 3 ? 12 : 0;
  let driftX = 0;
  let driftY = 0;
  if (visualOffset === 0) {
    driftY = -8;
  } else if (visualOffset === 2) {
    driftY = 10;
  } else {
    driftX = towardCenterPx * 0.45;
    driftY = -5;
  }
  return { visualOffset, tailUp, towardCenterPx, driftX, driftY };
}
